/* eslint-disable camelcase */

import EnvironmentService from './../services/environmentService';
const ODM_USERS_BASE = {
    TEST: 'https://odm-cust-gui.test.odm.bmw-fleet.net/',
    INT: 'https://odm-cust-gui.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-cust-gui.prod.odm.bmw-fleet.net/'
};

const LOGFILES_BASE = {
    TEST: 'https://odm-logfiles-service-frontend.test.odm.bmw-fleet.net/',
    INT: 'https://odm-logfiles-service-frontend.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-logfiles-service-frontend.prod.odm.bmw-fleet.net/'
};
const EMEA_URBAN_PILOT_BASE = {
    TEST: 'https://odm-urban-pilot-gui.test.odm.bmw-fleet.net/',
    INT: 'https://odm-urban-pilot-gui.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-urban-pilot-gui.prod.odm.bmw-fleet.net/'
};

const VEHICLE_DATA_BASE = {
    TEST: 'https://odm-vehicle-lifecycle-micro-ui.test.odm.bmw-fleet.net/',
    INT: 'https://odm-vehicle-lifecycle-micro-ui.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-vehicle-lifecycle-micro-ui.prod.odm.bmw-fleet.net/'
};

const FLEET_DATA_BASE = {
    TEST: 'https://odm-frontend-fleet-lifecycle.test.odm.bmw-fleet.net/',
    INT: 'https://odm-frontend-fleet-lifecycle.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-frontend-fleet-lifecycle.prod.odm.bmw-fleet.net/'
};

const ROLLOUT_TOOL = {
    TEST: 'https://cs-rollout-v2-frontend.test.odm.bmw-fleet.net/',
    INT: 'https://cs-rollout-v2-frontend.int.odm.bmw-fleet.net/',
    PROD: 'https://cs-rollout-v2-frontend.prod.odm.bmw-fleet.net/'
};

const BILLING_DATA_BASE = {
    TEST: 'https://csls-billing-data-ui.test.odm.bmw-fleet.net/',
    INT: 'https://csls-billing-data-ui.int.odm.bmw-fleet.net/',
    PROD: 'https://csls-billing-data-ui.prod.odm.bmw-fleet.net/'
};

const RAR_ADMIN_PARTNER = {
    TEST: 'https://rentaride-partner-admin.test.odm.bmw-fleet.net/',
    INT: 'https://rentaride-partner-admin.int.odm.bmw-fleet.net/',
    PROD: 'https://rentaride-partner-admin.prod.odm.bmw-fleet.net/'
};

const FUELFORLIFE_ADMIN = {
    TEST: 'https://ffl-partner-admin.test.odm.bmw-fleet.net/',
    INT: 'https://ffl-partner-admin.int.odm.bmw-fleet.net/',
    PROD: 'https://ffl-partner-admin.prod.odm.bmw-fleet.net/'
};

const CS_LIGHT_BASE = {
    fleet: {
        TEST: 'https://cslight-fleet-operation-service.int.odm.bmw-fleet.net/',
        INT: 'https://cslight-fleet-operation-service.int.odm.bmw-fleet.net/',
        PROD: 'https://cslight-fleet-operation-service.prod.odm.bmw-fleet.net/'
    },
    rental: {
        TEST: 'https://cslight-rental-service.int.odm.bmw-fleet.net/',
        INT: 'https://cslight-rental-service.int.odm.bmw-fleet.net/',
        PROD: 'https://cslight-rental-service.prod.odm.bmw-fleet.net/'
    },
    geoArea: {
        TEST: 'https://cslight-geo-area-service.int.odm.bmw-fleet.net/',
        INT: 'https://cslight-geo-area-service.int.odm.bmw-fleet.net/',
        PROD: 'https://cslight-geo-area-service.prod.odm.bmw-fleet.net/'
    },
    summary: {
        TEST: 'https://cslight-rental-service.int.odm.bmw-fleet.net/summaries',
        INT: 'https://cslight-rental-service.int.odm.bmw-fleet.net/summaries',
        PROD: 'https://cslight-rental-service.prod.odm.bmw-fleet.net/summaries'
    },
    drivers: {
        TEST: 'https://cslight-accounts.int.odm.bmw-fleet.net/',
        INT: 'https://cslight-accounts.int.odm.bmw-fleet.net/',
        PROD: 'https://cslight-accounts.prod.odm.bmw-fleet.net/'
    },
    operations: {
        TEST: 'https://cslight-operations.int.odm.bmw-fleet.net/',
        INT: 'https://cslight-operations.int.odm.bmw-fleet.net/',
        PROD: 'https://cslight-operations.prod.odm.bmw-fleet.net/'
    },
    logbook: {
        TEST: 'https://cslight-logbook-service.test.odm.bmw-fleet.net/',
        INT: 'https://cslight-logbook-service.int.odm.bmw-fleet.net/',
        PROD: 'https://cslight-logbook-service.prod.odm.bmw-fleet.net/'
    }
};

const RMP = (() => {
    return {
        TEST: 'https://rmp-frontend.test.odm.bmw-fleet.net/',
        INT: 'https://rmp-frontend.int.odm.bmw-fleet.net/',
        PROD: 'https://rmp-frontend.prod.odm.bmw-fleet.net/'
    };
})();

const ROAD_CLEARANCE = {
    TEST: 'https://roadclearance.test.odm.eu-central-1.bmw-fleet.net/',
    INT: 'https://roadclearance.int.odm.eu-central-1.bmw-fleet.net/'
};

const FAPIAO_BASE = {
    fapiao: {
        TEST: 'https://odm-fapiao.rhcn-fapiao-service.int.odm.reachnow.cn/', // no test environment
        INT: 'https://odm-fapiao.rhcn-fapiao-service.int.odm.reachnow.cn/',
        PROD: 'https://odm-fapiao.rhcn-fapiao-service.prod.odm.reachnow.cn/'
    },
    complaint: {
        TEST: 'https://odm-fapiao.rhcn-complaint-service.int.odm.reachnow.cn/', // no test environment
        INT: 'https://odm-fapiao.rhcn-complaint-service.int.odm.reachnow.cn/',
        PROD: 'https://odm-fapiao.rhcn-complaint-service.prod.odm.reachnow.cn/'
    }
};

const TELEOP_BASE = {
    TEST: 'https://teleop-frontend-cockpit.test.odm.bmw-fleet.net/',
    INT: 'https://teleop-frontend-cockpit.int.odm.bmw-fleet.net/',
    PROD: 'https://teleop-frontend-cockpit.prod.odm.bmw-fleet.net/'
};

const ADMINISTRATION = {
    TEST: 'https://odm-frontend-iamnext.test.odm.bmw-fleet.net/',
    INT: 'https://odm-frontend-iamnext.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-frontend-iamnext.prod.odm.bmw-fleet.net/'
};

const RH_VEHICLE_SCHEDULE = {
    TEST: 'https://rh-vehicle-schedule-frontend.test.odm.bmw-fleet.net/',
    INT: 'https://rh-vehicle-schedule-frontend.int.odm.bmw-fleet.net/',
    PROD: 'https://rh-vehicle-schedule-frontend.prod.odm.bmw-fleet.net/'
};

const TECHONLY_APP_MANAGE = {
    TEST: 'https://odm-techonly-app-admin-frontend.test.odm.bmw-fleet.net/',
    INT: 'https://odm-techonly-app-admin-frontend.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-techonly-app-admin-frontend.prod.odm.bmw-fleet.net/'
};

const MESSAGE_VIEWER = {
    TEST: 'https://odm-message-viewer-frontend.test.odm.bmw-fleet.net/',
    INT: 'https://odm-message-viewer-frontend.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-message-viewer-frontend.prod.odm.bmw-fleet.net/'
};

const VEHICLE_SHADOW = {
    TEST: 'https://odm-vehicle-connectivity-frontend.test.odm.bmw-fleet.net/',
    INT: 'https://odm-vehicle-connectivity-frontend.int.odm.bmw-fleet.net/',
    PROD: 'https://odm-vehicle-connectivity-frontend.prod.odm.bmw-fleet.net/'
};

let environment = EnvironmentService.getEnvironment();

function getBase(config) {
    switch (environment) {
        case 'LOCAL':
        case 'TEST':
            return config.TEST; // TEST entry needs to be available
        case 'INT':
            return config.INT || config.TEST;
        case 'PROD':
            return config.PROD || config.INT || config.TEST;
        default:
            return config.TEST;
    }
}

export default {
    external_vehicle_data: getBase(VEHICLE_DATA_BASE) + '#/',
    external_fleet_data_operator: getBase(FLEET_DATA_BASE) + '#/operator/view',
    external_fleet_data_subsidiary: getBase(FLEET_DATA_BASE) + '#/subsidiary/view',
    external_fleet_data_fleet: getBase(FLEET_DATA_BASE) + '#/fleet/view',
    external_urban_pilot: getBase(EMEA_URBAN_PILOT_BASE) + 'dashboard/member-overview',
    external_rollout_tool: getBase(ROLLOUT_TOOL) + '#/',
    external_vehicle_billing_data: getBase(BILLING_DATA_BASE) + '#/',
    external_rentaride_partner_admin: getBase(RAR_ADMIN_PARTNER) + '#/',
    'iamn-external_fuelforlife_admin': getBase(FUELFORLIFE_ADMIN) + '#/',
    external_cslight_emea_vehicle_data: getBase(CS_LIGHT_BASE.fleet) + 'vehicles',
    external_cslight_emea_vehicle_groups: getBase(CS_LIGHT_BASE.fleet) + 'vehicle-groups',
    external_cslight_emea_damage_management: getBase(CS_LIGHT_BASE.fleet) + 'vehicle-damages',
    external_cslight_emea_calender: getBase(CS_LIGHT_BASE.rental) + 'bookings',
    external_cslight_emea_trip_report: getBase(CS_LIGHT_BASE.rental) + 'reports',
    external_cslight_emea_stations: getBase(CS_LIGHT_BASE.geoArea) + 'stations',
    external_cslight_emea_trip_parameter: getBase(CS_LIGHT_BASE.operations) + 'settings',
    external_cslight_emea_operators: getBase(CS_LIGHT_BASE.operations) + 'operators',
    external_cslight_emea_tariffs: getBase(CS_LIGHT_BASE.rental) + 'tariffs',
    external_cslight_emea_summary: getBase(CS_LIGHT_BASE.summary) + '#/',
    external_cslight_emea_drivers: getBase(CS_LIGHT_BASE.drivers) + 'drivers',
    'iamn-external_cslight_trips_logbook': getBase(CS_LIGHT_BASE.logbook) + 'logbook',
    external_rcv_emea_viewer: getBase(ROAD_CLEARANCE) + '#/',
    external_log_files: getBase(LOGFILES_BASE) + '#/',
    external_cn_fapiao_overview: getBase(FAPIAO_BASE.fapiao) + 'overview',
    external_cn_fapiao_complaints: getBase(FAPIAO_BASE.complaint) + 'overview',
    teleop_tasks_ongoing: getBase(TELEOP_BASE) + '#/tasks',
    teleop_tasks_archive: getBase(TELEOP_BASE) + '#/tasks/archive',
    teleop_sessions_ongoing: getBase(TELEOP_BASE) + '#/sessions',
    teleop_sessions_archive: getBase(TELEOP_BASE) + '#/sessions/archive',
    iamnext_groups_view: getBase(ADMINISTRATION),
    iamnext_permissions_view: getBase(ADMINISTRATION) + '#/permission',
    iamnext_users_view: getBase(ADMINISTRATION) + '#/user',
    external_rmp: getBase(RMP),
    external_people_odm_customer_mgmt: getBase(ODM_USERS_BASE),
    'iamn-external_cust_data_export': getBase(ODM_USERS_BASE) + 'exportData',
    rh_vehicle_schedule_view: getBase(RH_VEHICLE_SCHEDULE),
    external_techonly_app_manage_permissions: getBase(TECHONLY_APP_MANAGE),
    external_message_viewer: getBase(MESSAGE_VIEWER),
    external_vehicle_shadow: getBase(VEHICLE_SHADOW),
    // Just for testing!
    __getBase: getBase,
    __setEnvironment(env) {
        environment = env;
    }
};
